import {
  FilterType,
  buildFundaeFinishGroupDatatableFilter,
  useFundaeFinishGroupDatatable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  source: ReturnType<typeof useFundaeFinishGroupDatatable>
}
export const missingDataFilter = ({ source }: Props) => {
  return buildFundaeFinishGroupDatatableFilter(source, {
    type: FilterType.Boolean,
    default: true,
    onUpdateValue(value) {
      track(trackingEvents.training.trainingDetail.fundae.finishGroupsExport.missingDataFilter, {
        selected_filter: value ? 'missing_data' : 'all_participants',
      })
    },
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options: [
          {
            label: i18n.t(
              'trainings.trainings_detail.fundae.participants_datatable.missing_data_filter.missing_data'
            ),
            value: true,
          },
          {
            label: i18n.t(
              'trainings.trainings_detail.fundae.participants_datatable.missing_data_filter.all'
            ),
            value: false,
          },
        ],
      },
    ],
    identifier: 'missingData',
    path: 'missingData',
    title: i18n.t('trainings.fundae.finish_group_table.filters.missing_data'),
  })
}
